// 案例數據
export const caseStudies = [
  {
    id: "poc-custom-dev",
    category: "integration",
    title: "概念実証（POC）およびカスタマイズ開発",
    client: "複数の法人顧客／企業クライアント",
    summary:
      "実際の現場ニーズに基づき、AIアルゴリズムとソフト・ハード統合のカスタマイズ開発を提供します。迅速なプロトタイプ検証に対応し、その後の拡張や製品化もサポート。スマートシステムの導入を加速し、革新的な構想の実現を支援します。",
    description:
      "当プロジェクトは、POC（概念実証）とカスタマイズ型スマートシステム開発に注力し、現場のニーズに基づいてAIアルゴリズムとハード・ソフト統合技術を組み合わせ、クライアントに最適化されたアプリケーションソリューションを構築します。モジュール型の開発プロセスとユーザー協働により、迅速なプロトタイプ作成と機能検証、現場環境でのテストとチューニングが可能です。アーキテクチャは高い柔軟性と拡張性を持ち、データ連携や機能拡張に対応し、製品化やスケール展開を容易にします。ニーズ定義、設計・実装、モデル学習、検証・導入まで一貫対応し、革新アイデアの迅速な実装と持続的な運用を支援します。",
    tags: ["カスタマイズ開発", "AI アルゴリズム", "ソフトウェア・ハードウェア統合合"],
    achievements: [
      {
        label: "顧客と連携して要件と設計仕様を明確化し、迅速にプロトタイプ開発に着手",
        value: "迅速なプロトタイプ開発",
      },
      {
        label: "小規模データによる学習とシミュレーション検証を通じ、アルゴリズムの精度と性能を効果的に検証",
        value: "AIモデル導入の迅速化",
      },
      {
        label: "データ収集・ロジック処理・デバイス制御などの機能モジュールを統合し、一貫したシステム動作を実現しました。",
        value: "跨模組整合完成モジュール横断的な統合の実現",
      },
      {
        label: "実際の利用シーンにおいてテストを行い、フィードバックに基づき機能やUI/UXを調整",
        value: "実環境での検証と最適化",
      },
      {
        label: "APIおよびデータ連携用インターフェースを予め設計し、将来的な製品化やスケール展開を支援します",
        value: "拡張性の高いアプリケーションアーキテクチャ",
      },
      {
        label: "現場での安定稼働を継続的にサポートし、保守・アップデートサービスを提供。リアルタイムなシステム運用を保証",
        value: "システムの安定稼働と本番環境導入",
      },
      {
        label: "チームのアイデアを具体的な実装へと導き、実用可能なスマートアプリケーションソリューションを構築します。",
        value: "アイデア実現と具現化",
      },
    ],
    clients: [
      "泉創生医：VitaPCRデータ送信システム",
      "高雄医科大学：保健局向けWebクローラー開発",
      "高雄医科大学「創心力」チーム：心拍数スマートバンドアプリ開発",
      "理略バイオテック - Ultrasound Needle Guide",
    ],
    details: {
      challenges: [
        "応用シナリオが複雑で、要件を明確に定義することが困難",
        "従来の開発モデルではアイデアの実現可能性を迅速に検証できない",
        "システムはハードウェア、ファームウェア、アルゴリズム設計を同時に統合する必要がある",
        "実務経験を有する技術統合パートナーが不足している",
        "現場の状況に応じて機能やインターフェースを即時に調整できない",
        "長期的な運用保守や継続的な最適化能力が不足している",
      ],
      highlights: [
        "モジュール化開発アーキテクチャにより、迅速なプロトタイプ開発をサポート。",
        "AIアルゴリズムとハードウェア機器をシームレスに統合",
        "拡張インターフェースを事前に確保し、将来的な製品化に対応",
        "実地検証メカニズムにより、システムの実用性を確保",
      ],
    },
    featured: true,
  },
  {
    id: "icu-aiot-system",
    category: "medical",
    title: "ICU向け音声検知AIoTシステム",
    client: "中山医学大学附属病院",
    summary:
      "ICU向けに設計された本システムは、音声AIにより医療機器の異常警報音を識別し、自動でナースコールやライト通知を発動。看護師がベッドサイドにいなくても即時に状況把握が可能となり、警報反応の効率が向上、看護負担が軽減され、患者安全が強化されます。これこそがスマート病棟には欠かせないソリューションです。",
    description:
      "本プロジェクトはICU向けにカスタム設計されたAIoT警報補助システムであり、音声AI技術を活用して各種医療機器の異常警報音をリアルタイムに認識し、自動でナースコールとライト表示を作動させます。ICU内の看護比率の不均衡・多数機器による複雑な環境雑音という課題に対応し、本システムは多床・多地点にわたる警報をスマートに監視。看護師が病床にいなくても異常を即時把握し迅速対応が可能です。24時間稼働可能で、既存のナースステーションおよび呼出システムとの統合をサポートし、警報精度と反応効率を大幅に向上させます。設計は看護負担の軽減、医療リスクの低減、患者安全と医療品質の向上に重きを置き、ICUにおいてより効率的でスマートなケアプロセスを実現するソリューションです。",
    tags: ["AI 音声認識", "IoT 応用", "スマート医療", "リアルタイム監視"],
    achievements: [
      {
        label: "平均5～8分を1分以内に短縮",
        value: "警報対応時間を85%短縮",
      },
      { label: "元々約20%であったものを1%以下に削減", 
        value: "警報見逃し率を95%低減" },
      {
        label: "不要な巡回頻度を削減し、人員配置を最適化",
        value: "看護業務効率を30%上昇",
      },
      {
        label: "リアルタイム警報機構により、緊急事態に即時対応が可能",
        value: "緊急対応速度アップ",
      },
      {
        label: "看護スタッフが病室内、廊下、ナースステーションどこにいても警報を受信可能",
        value: "マルチポイントカバレッジ",
      },
      {
        label: "AIシステムによる24時間スマートモニタリングサービスを提供",
        value: "24時間体制で監視します",
      },
      {
        label: "対応の遅れによる医療トラブルリスクを低減",
        value: "医療リスクを低減",
      },
      {
        label: "看護スタッフの業務負荷と心理的ストレスを軽減",
        value: "看護現場の満足度アップ",
      },
      {
        label: "精密な警報システムにより病棟管理効率アップ",
        value: "資源配置の最適化",
      },
    ],
    clients: ["中山医学大学附属病院 急性呼吸病棟警報システム"],
    details: {
      challenges: [
        "ICUの環境は騒音が複雑で、多様な医療機器が同時稼働しています",
        "看護対患者比のアンバランスにより、看護師が長時間ベッドサイドに張り付きになります",
        "従来の集中監視システムには対応遅延の問題があります",
        "看護スタッフが他のベッド（病棟）の機器異常警報を即座に察知できません",
      ],
      highlights: [
        "AI音声認識アルゴリズムにより、複雑な環境下でも医療機器からの警報音を高精度に識別",
        "複数点にわたるカバレッジシステムにより、エリア全域を死角なく監視",
        "リアルタイム警報機構と複数通知方式に対応",
        "医療リスクを低減し、看護満足度上昇",
      ],
    },
    featured: true,
  },
  {
    id: "anxin-ecg-system",
    category: "medical",
    title: "安心モア：救急車用 ECG（心電図）リアルタイム送信システム",
    client: "屏東県消防局",
    summary:
      "救急隊員が現場や搬送中の救急車内から心電図データを送信し、医師が遠隔で即時読影・判読を行います。STEMI（ST上昇型心筋梗塞）と判断された場合は、迅速にカテーテル治療が可能な病院へ直送することで、二次搬送を回避し、ゴールデンタイム内での治療実施を支援します。システムはHIS（病院情報システム）やPACS（画像保存通信システム）との連携に対応しており、医療機関の事前準備を可能にすることで、救命率と緊急医療の質を大幅に向上させます。",
    description:
      "本システムは、急性心筋梗塞（STEMI） の救急対応効率を高めることを目的に開発されました。心電図検査を現場（救急車内）で実施し、そのデータをリアルタイムでクラウドにアップロード。医師が遠隔で解析・判断を行うことで、救急隊が即座に搬送先を判断し、心カテーテル治療が可能な医療機関に直接搬送することが可能になります。また、モバイル端末と医療機関の HIS/PACS システムとの連携により、患者が到着する前に医療側の準備が整えられるほか、医療情報の即時共有と業務効率化が実現されます。このように、デジタル化とスマート化を融合させたワークフローにより、「ゴールデンタイム（90分以内）」の治療開始を可能にし、救命率と診療品質を大幅に向上させます。本システムは、救急と医療の連携強化に貢献する、次世代の救急医療ソリューションです。",
    tags: ["救急医療", "リアルタイムデータ伝送", "遠隔診断システム", "遠隔診断 × システム統合"],
    achievements: [
      { label: "現場で初期診断・判断が可能", value: "救急判断効率 70％以上向上" },
      {
        label: "患者が病院に到着する前に医療側の準備が完了",
        value: "医療対応開始時間が10～20分前倒しに",
      },
      {
        label: "適切な医療機関へ直接搬送、二次搬送を回避",
        value: "転送率の低減",
      },
      { label: "救急隊と医療チームとのシームレスな連携", value: "情報のリアルタイム伝送" },
      {
        label: "即時解析と標準化されたデータ伝送により診断精度を向上",
        value: "診断の正確性が向上",
      },
      { label: "病院到着後すぐに治療を開始、待機時間と患者の不安を軽減", value: "患者体験の改善" },
    ],
    clients: ["屏東県消防局（地元医療機関との連携による導入）"],
    details: {
      challenges: [
        "現行の救急プロセスでは、90分以内の血流再開（再灌流）が困難",
        "カテーテル室を持たない病院に搬送された場合は再搬送が必要",
        "搬送中に STEMIの確定診断ができない",
        "医療機関側が 事前に人員や設備を手配できず、対応が後手に",
      ],
      highlights: [
        "リアルタイム心電図データのアップロードおよび解析プラットフォームの構築",
        "医療機関のHIS（病院情報システム）およびPACS（医用画像保管通信システム）との連携による統合的な診療記録管理の実現",
        "モバイル端末とPC端末の双方に対応した同期操作機能を搭載",
        "誤診リスクの軽減および診断精度の向上",
      ],
    },
    featured: true,
  },
  {
    id: "jpr-ecg-management",
    category: "medical",
    title: " JPR – 心電図フルデジタル管理システム",
    client: "屏東キリスト教病院",
    summary:
      "救急外来、外来診療、健康診断など各診療科の心電図画像を一元管理し、検査オーダーの自動マッチング、レポート作成・保険申請業務の迅速化を実現。さらに、PACS・HISとのシームレスな連携により、作業効率とデータ整合性の向上を支援し、心電図デジタル化の基盤となるワンストップ管理プラットフォームを構築します。",
    description:
      "画像取得、オーダーマッチング、検査結果の確認、レポート作成まで、心電図に関する業務を全面的にデジタル化。既存のPACSおよびHISと完全に連携可能で、救急外来、外来、健診センターなど複数診療部門からの心電図データを統一管理。データの分散やマッチングミスを防ぎます。自動マッチングと画像統合技術により、手作業の負担を軽減し、レポート作成や検索時間を大幅に短縮。自動アップロード・保険申請機能も備え、保険業務の効率化と申請ミスの防止に貢献します。アクセス権管理とバックアップ機能を内蔵しており、医療情報の安全性と一貫性を強化。病院の医療サービス品質向上と、医療ITデジタル化推進の重要な基盤となります。",
    tags: ["PACS統合", "自動化プロセス", "デジタルトランスフォーメーション", "医療情報"],
    achievements: [
      {
        label: "自動QCマッチング機能により手作業時間を大幅に削減",
        value: "画像処理効率85％向上",
      },
      {
        label: "自動画像統合およびアップロード機構により業務効率を大幅に改善",
        value: "レポート作成時間60％短縮",
      },
      {
        label: "統一ビューイングプラットフォームにより、各科室が必要なデータへ迅速にアクセス可能",
        value: "検索応答速度90％向上",
      },
    ],
    clients: ["屏東キリスト教病院"],
    details: {
      challenges: [
        "心電図画像の発生源が分散しており、救急、一般検査、健診など複数の科室にまたがっている",
        "手作業による媒合作業は時間と労力を要し、誤ったマッチングが発生しやすい",
        "統一された画像閲覧プラットフォームがなく、各部門での検索が困難",
        "レポート作成フローが煩雑で、画像統合作業の効率が低い",
        "既存のPACSおよびHISシステムとの統合度が不足している",
        "台湾健保請求プロセスが煩雑で、行政的負担が増大",
      ],
      highlights: [
        "ワンストップサービスにより、画像収集からレポート完成までの完全なデジタルフローを実現",
        "救急、外来、健診などすべての部門を横断的に統合し、共通のプラットフォームを提供",
        "PACS、HISシステムとシームレスに統合し、データの一貫性を確保",
        "完全なデータバックアップおよびアクセス権限管理メカニズムを搭載",
      ],
    },
    featured: false,
  },
  {
    id: "vital-signs-integration",
    category: "medical",
    title: "生体モニター連携アップロードシステム",
    client: "衛生福利部病院体系",
    summary:
      "「スキャン・測定・確認」の3ステップで操作フローを簡略化し、看護スタッフが生体データを迅速かつ正確にNIS（看護情報システム）へ自動アップロードできるように設計された本システムは、業務効率の向上と入力ミスの削減に大きく貢献します。スマート病室の実現に欠かせないソリューションです。",
    description:
      "本プロジェクトで開発された「生体モニター自動アップロードシステム」は、血圧・心拍・体温・血中酸素濃度などの患者の生体データを、スキャン・測定・確認の簡潔な3ステップでNISにリアルタイム統合するものです。従来の病棟における手書き記録および手動入力の煩雑な作業を解消し、ヒューマンエラーを減らしながら業務時間を大幅に短縮します。実際に導入された病院では、看護師一人あたり1日平均1時間の入力業務を削減できています。本システムは既存の医療機器との互換性が高く、機器の交換なしで導入可能です。最低限のコストでスマート化を実現し、病棟全体のケア品質および患者の安全性を向上させることができます。まさに、スマート病室構築および看護業務最適化のための重要なソリューションです。",
    tags: ["看護情報", "自動アップロード", "プロセス最適化", "データ統合"],
    achievements: [
      {
        label: "測定時間を5分から1.5分に短縮し、看護師の1日あたりの入力作業時間を1時間削減",
        value: "業務効率70％向上",
      },
      {
        label: "手作業によるエラー率を低減し、即時アップロードでデータ消失リスクを削減",
        value: "データ精度改善",
      },
      {
        label: "モニターと看護システムを統合し、複数の生理パラメータ自動取得に対応",
        value: "システム統合完了",
      },
      { label: "3ステップで完了：スキャン → 測定 → アップロード", value: "プロセス大幅簡素化" },
    ],
    clients: ["衛生福利部新営医院", "衛生福利部台中医院"],
    details: {
      challenges: [
        "従来の病棟における生理測定作業フローが煩雑",
        "看護師が各生理データを手書きで記録し、その後一つずつ看護情報システムに入力する必要がある",
        "時間と労力がかかるだけでなく、人為的エラーが発生しやすい",
        "病院は看護人材不足の課題に直面している",
      ],
      highlights: [
        "3ステップで簡素化されたフロー：患者リストバンドのスキャン → 生理測定 → アップロード確認",
        "既存の生理モニター機器と看護情報システムの統合に成功",
        "複数の生理パラメータ自動取得をサポート",
        "リアルタイムデータ送信により、データ完全性を保証",
      ],
    },
    featured: false,
  },
  {
    id: "physio-measurement-system",
    category: "medical",
    title: "生体測定機器統合アップロードシステム",
    client: "国軍桃園総医院など",
    summary:
      "血圧計や身長体重計など複数の生体測定機器を統合し、直感的に使えるタッチ操作で、測定データを即時に医療情報システムへアップロードします。これにより、医療機関の測定業務効率とデータ管理品質を大幅に向上させ、患者にとってもより便利で安心できる受診体験を提供します。",
    description:
      "本システムは主要な生体測定機器を統合し、直感的な操作インターフェースを備えています。保険証の読み取りまたは手入力に対応し、医療スタッフや患者が迅速に測定を完了できます。測定後はデータがリアルタイムで保存・アップロードされ、患者または医療スタッフと共有可能。医療機関全体の業務効率とデータの正確性を向上させます。従来は、機器が個別に稼働し操作が煩雑で、データのリアルタイム統合ができず、人員負担とデータ追跡の困難が課題でした。本システム導入により、測定ワークフローが大幅に簡素化され、既存医療情報システムへ統合可能。スマート医療のレベルアップをサポートし、手作業エラーや二重作業を削減し、患者の利便性と安全性を高めることに成功しています。",
    tags: ["設備整合", "智慧身份識別", "即時處理", "多元分享"],
    achievements: [
      {
        label: "統合操作インターフェースにより、1回の測定時間を平均5分から2分へ短縮",
        value: "操作効率60％向上",
      },
      { label: "データ自動送信により、手作業による転記ミスを削減", value: "データ精度85％向上" },
      { label: "統合管理プラットフォームにより、機器の利用効率を向上", value: "機器利用率40％向上" },
      { label: "自動化プロセスにより、看護師の重複作業を削減", value: "人件費30％削減" },
    ],
    clients: [
      "国軍桃園総医院：血圧計測データ自動アップロードシステム",
      "大檜渓コミュニティ発展協会：血圧計測データ自動アップロードシステム",
      "禾悦クリニック：血圧計測データ自動アップロードシステム",
    ],
    details: {
      challenges: [
        "機器統合の困難：血圧計、身長体重計などの生理測定機器がそれぞれ独立して稼働",
        "操作フローの複雑さ：利用者と看護師がそれぞれ異なる機器を操作する必要がある",
        "データ管理の分散：測定結果を病院情報システムに即時統合できない",
        "ユーザー体験の不十分さ：直感的な操作インターフェースが不足",
        "データ追跡の困難さ：患者の長期的な生理データ変化を効果的に追跡できない",
      ],
      highlights: [
        "複数機器統合：血圧計、身長体重計など複数の生理測定機器を統合",
        "スマートID認証：健康保険証の挿入による自動識別および手動入力に対応",
        "リアルタイムデータ処理：測定結果を即時に表示・保存・処理",
        "ユーザーフレンドリーなUI：直感的なタッチ操作インターフェースで幅広い年齢層に対応",
      ],
    },
    featured: false,
  },
  {
    id: "ecg-image-conversion",
    category: "medical",
    title: "心電図画像変換・アップロードシステム",
    client: "複数の医療機関",
    summary:
      "本システムは複数の医療機関向けにカスタマイズされたソリューションであり、診察室にて心電図画像をリアルタイムにDICOM形式へ変換・アップロードすることで、煩雑なプロセスと手入力を排除します。各種メーカー製心電計に対応し、迅速な患者データ登録と心電図検査業務の効率化を実現。医療スタッフがケアに注力でき、作業フロー全体を最適化します。",
    description:
      "軽量なシステム構成と柔軟な統合能力により、従来の大型システム導入に伴う高コスト・複雑な導入プロセスを不要とし、診察室内で迅速に心電図データの処理・登録が可能です。多数の心電計ブランドに対応し、既存のHISおよびPACSプラットフォームと統合。これにより、システムの運用負担を軽減しつつ、医療データ電子化を加速します。導入後は医療スタッフが患者ケアに集中でき、後端の情報は自動で同期アップロードされ、診療室の業務の流れと医療の質が向上しました。",
    tags: ["DICOM変換", "PACS統合", "軽量導入", "リアルタイム処理"],
    achievements: [
      {
        label: "心電図検査後の処理時間を平均70％削減",
        value: "平均処理時間70％短縮",
      },
      {
        label: "DICOMフォーマット変換成功率100％を達成",
        value: "データ変換精度100％",
      },
      {
        label: "既存PACSシステムとの100％互換性を確保し、追加ハード投資不要",
        value: "システム統合度100％",
      },
      {
        label: "平均1～3営業日でシステム導入を完了、従来の大規模システムと比べて80％の導入時間を削減",
        value: "導入時間80％削減",
      },
    ],
    clients: [
      "台北榮民総医院台東分院（画像変換ソフトウェア）",
      "成功大学附属病院斗六分院（心電図アップロードシステム）",
      "屏安医療法人屏安医院（心電図アップロードシステム）",
      "桃園市立病院健康診断センター（心電図伝送システム）",
    ],
    details: {
      challenges: [
        "心電図装置の多様化により、統一されたデータ変換機構が不足している",
        "検査データを手動で処理する必要があり、病院情報システムへ即時統合できない",
        "PACS (Picture Archiving and Communication System) へのアップロード手順が煩雑",
        "診察室での業務フローが円滑でなく、医療従事者の業務効率に影響",
        "柔軟なシステム統合ソリューションが不足しており、大規模システム導入コストが高い",
      ],
      highlights: [
        "軽量ソリューションにより、大規模システムを導入せずに即時で完全なサービスを提供",
        "多種多様な心電図装置のデータフォーマット変換をサポート",
        "リアルタイムのDICOM変換およびPACSへのアップロード機能",
        "迅速な導入により、システム導入コストを大幅に削減",
      ],
    },
    featured: false,
  },
  {
    id: "jaundice-digital-system",
    category: "medical",
    title: "ビリルビン測定器デジタル統合システム",
    client: "台湾全土の数十の病院に導入済み",
    summary:
      "2010年より現在まで、台湾全土の数十の医療機関にて継続的に運用されており、ビリルビン測定器のデータを自動的に医療情報システムへアップロードすることで、手書きによる転記作業を省略し、検査効率の向上と誤記入の削減を実現しています。13年以上にわたり安定した稼働を維持し、医療現場から高い評価をいただいています。",
    description:
      "ビリルビン測定器のデジタル化運用に特化して設計された本システムは、カスタマイズ開発による接続プログラムを通じて、測定データを自動的に病院の情報システム（HIS／LIS）へアップロードすることを実現しています。2010年より現在に至るまで、台湾全土の数十の医療機関に安定的に導入されており、臨床現場における手書きや手動入力の作業を省略し、検査効率の大幅な向上と人的エラーのリスク低減に成功しています。本システムは高い互換性を備えており、各医療機関の運用要件に応じたワークフロー調整および情報システムとの統合が可能です。これにより、標準化された検査業務プロセスの構築と、検体データ管理効率の全面的な強化を支援します。13年以上にわたる安定運用は、高い信頼性と低コストなメンテナンス性を証明しており、現在、医療機関における機器データ統合の実用的かつ効果的なソリューションの一つとして、検査技師や看護スタッフからも高く評価されています。",
    tags: ["デジタルトランスフォーメーション", "自動アップロード", "長期運用", "標準化プロセス"],
    achievements: [
      {
        label: "台湾全域で数十の病院をカバーし、2010年から現在まで13年以上の安定稼働実績",
        value: "広範なサービス範囲",
      },
      {
        label: "検査データ処理時間を80％削減し、人為的入力ミスを95％以上低減",
        value: "効率の大幅向上",
      },
      {
        label: "各病院で年間平均15～20％の人件費を削減し、保守コストも低廉",
        value: "顕著なコスト効果",
      },
      {
        label: "専用SOPを策定し作業の一貫性を向上、既存HIS/LISシステムとの統合に成功",
        value: "プロセス標準化の最適化",
      },
      {
        label: "検査データの完全性と正確性を保証し、長期運用でも重大なシステム障害なし",
        value: "データ品質の保証",
      },
      {
        label: "医療従事者から高く評価され、操作の利便性と技術の安定性が大幅に向上",
        value: "ユーザー高満足度",
      },
    ],
    clients: [
      "国立台湾大学医学院附属病院グループ（本院、児童医院、新竹、生医竹北、生医竹中、虎尾、斗六）",
      "高雄医学大学附属病院グループ（本院、岡山分院、大同医院）",
      "栄民総医院グループ（台北、台中）",
      "奇美医院グループ（永康、柳営）",
      "慈済医院グループ（台中、花蓮、大林、嘉義、高雄）",
      "長庚記念医院グループ（基隆、台北、桃園）",
      "台北市立聯合医院",
      "部立土城医院",
      "阮綜合医院",
      "屏東キリスト教医院",
      "成功大学附属医院",
      "亜東記念医院",
    ],
    details: {
      challenges: [
        "データのサイロ化問題：測定機器から出力されるデータが病院の情報システム（HIS/LIS）に直接統合できない。",
        "手作業による負担：従来は検査スタッフが測定結果を手書きで記録し、手動で入力する必要があり、ミスが発生しやすく、作業に時間がかかる。",
        "業務プロセスの標準化ニーズ：病院によって検査科や臨床部門の運用フローが異なるため、カスタマイズされた運用設計が求められている。",
        "データ管理効率の課題：データ形式やアップロード手順が統一されておらず、情報管理の効率化が困難。",
      ],
      highlights: [
        "13年以上の安定稼働実績、成熟した信頼性の高い技術",
        "台湾全域の多数の有名病院をカバーし、主要病院グループを含む",
        "データの自動取得・アップロードにより、人為的ミスを大幅に削減",
        "病院ごとのニーズに応じたカスタマイズSOP策定",
      ],
    },
    featured: true,
  },
  {
    id: "restroom-smart-sensor",
    category: "iot",
    title: "トイレ内スマート監視システム",
    client: "高雄市立小港病院",
    summary:
      "磁気リードスイッチセンサーと赤外線動作検知を組み合わせ、ロジック判定アルゴリズムにより利用者の状態をリアルタイムで把握します。長時間の無動作など異常と判断される場合には、自動的に警報を発し、医療スタッフへ通知されます。これにより、トイレ利用中の異常事態を迅速に察知し、患者およびご家族の安全性とケアの質を向上させることが可能となります。",
    description:
      "「トイレ内スマート監視システム」は、マグネットリードスイッチと赤外線動作センサーを組み合わせることで、トイレ内の利用者の状態をリアルタイムで把握します。ロジック判定アルゴリズムにより、長時間の無動作などの異常を自動的に検出します。異常の兆候を検知した際には、システムが即座に警報を発し、医療スタッフが迅速に対応・処置できるよう支援します。これにより、トイレを一人で利用する患者の安全を確保することが可能になります。",
    tags: ["IoT 感測", "智慧運算", "安全監控", "即時警示"],
    achievements: [
      {
        label: "トイレ内の人体動作をリアルタイムで検知，一定時間動きがない場合、自動的に医療スタッフへ警告を通知",
        value: "安全監視および警告機能",
      },
      {
        label: "リードスイッチとPIR人感センサーのデータを統合，多段階のロジック判定により、誤報率を低減し、検知精度を向上",
        value: "インテリジェントな演算処理と高精度検知",
      },
      {
        label: "実際に導入された現場において、異常の早期発見と迅速な対応を実現し，トイレ安全監視の観点から、優れたモデルケースとしての実績を確立します",
        value: "実際の導入と運用実績",
      },
      {
        label: "ドアが閉まっており、かつ動きが検出されない場合、システムは自動的に監視モードへ移行",
        value: "自動モード切替機能",
      },
    ],
    clients: ["高雄市立小港病院"],
    details: {
      challenges: [
        "独自に受診している患者が、トイレ使用中に転倒や失神などの突発的な状況により、自ら助けを求めることができなくなるケースでは、",
        "救命における貴重なゴールデンタイムを逃すリスクが極めて高くなります。",
        "共用トイレでは多くの利用者が他人に配慮して異常に気づきにくく、",
        "その結果として、潜在的なリスクや安全上の死角が生じやすくなります。",
      ],
      highlights: [
        "磁気リードセンサーと赤外線動作検知の二重技術を融合",
        "スマート演算とロジック判定アルゴリズムにより、検知精度を向上",
        "自動警報メカニズムを搭載し、人的介入を不要",
        "多層的な判定ロジックにより、誤検知や見逃しを大幅に低減",
      ],
    },
    featured: false,
  },
];

// 分類資訊
export const categories = [
  { id: "all", name: "事例一覧", count: caseStudies.length },
  {
    id: "medical",
    name: "医療",
    count: caseStudies.filter((c) => c.category === "medical").length,
  },
  { id: "sports", name: "スポーツ", count: 0 }, // 暫無運動案例
  { id: "bi", name: "ビジネスインテリジェンス", count: 0 }, // 暫無商業智慧案例
  {
    id: "iot",
    name: "IoT",
    count: caseStudies.filter((c) => c.category === "iot").length,
  },
  {
    id: "integration",
    name: "システム統合",
    count: caseStudies.filter((c) => c.category === "integration").length,
  },
];
